( function( $ ) {
	
	$(document).on('click', "a.header--search-link", function (e) {
		e.preventDefault();
		
		var currentDialog = aria.getCurrentDialog();
		
		if(currentDialog){
			//replaceDialog('mxwes-modal--new-window-warning', undefined, undefined);
			replaceDialog(e.target, 'mxwes-modal--search');
		}else{
			openDialog('mxwes-modal--search', this);	
		}
	});
	
	$(document).ready(function(){
		adjustScrollPadding();
	});
	
	$(window).on('resize', function(){
		adjustScrollPadding();
	});
	
	function adjustScrollPadding(){
		var headerHeight = $('#masthead').height();	
		$('html').css('scroll-padding-top', headerHeight+'px');
	}
	
	window.onscroll = function() {myFunction()};
	
	var header = document.getElementById("masthead");
	var sticky = header.offsetTop;
	
	function myFunction() {
	  if (window.pageYOffset > sticky) {
		header.classList.add("is-fixed");
	  } else {
		header.classList.remove("is-fixed");
	  }
	  
	  setTimeout(() => {
		adjustScrollPadding();
	  }, "500");
	  
	  
	}
	
	//$(".embed-container").fitVids();
	
	//iFrameResize({ log: true }, '.embed-container iframe');
	
	var offCanvasOptions = {
		modifiers: 'left, overlay', // default options
		triggerButton: '#triggerButton' // btn to open offcanvas
	}
	
	if($('html').attr('dir') == 'rtl'){
		offCanvasOptions['modifiers'] = 'right, overlay';
	}
	
	
	
	
	$('#offCanvas').offcanvas(offCanvasOptions);
	
	var primary_nav_off_canvas = $('#offCanvas').data('offcanvas-component');
	
	$('#offcanvas--main-menu__close').on('click', function(e){
		e.preventDefault();
		primary_nav_off_canvas.close();
	});
	

} )( jQuery );
